import classnames from 'classnames';

import { BuildingType } from 'src/types/cartography.types';

import styles from './BuildingRoof.module.scss';
import { Props } from './BuildingRoof.types';

type RoofKind = 'slate' | 'tile' | 'flat' | 'pool' | 'hedge';

const ROOF_BY_BUILDING_TYPE: Record<BuildingType, RoofKind> = {
  [BuildingType.MAIN_HOUSE]: 'slate',
  [BuildingType.APARTMENT]: 'flat',
  [BuildingType.ANNEX]: 'tile',
  [BuildingType.OUTBUILDING]: 'tile',
  [BuildingType.OTHER]: 'tile',
  [BuildingType.GARAGE]: 'flat',
  [BuildingType.POOL_HOUSE]: 'pool',
  [BuildingType.LAND]: 'hedge',
};

// Rooster silhouette lifted from the mockup, drawn once here so we don't repeat SVG.
const Rooster = () => (
  <svg className={styles.vane} viewBox="0 0 40 34" aria-hidden focusable="false">
    <line x1="20" y1="10" x2="20" y2="34" />
    <path d="M8 10 L32 10" />
    <path className="coq" d="M18 4 c2 -3 6 -3 8 0 c-2 3 -6 3 -8 0 Z" />
    <path d="M16 10 L14 6" />
    <path d="M24 10 L26 6" />
  </svg>
);

const Smoke = () => (
  <svg className={styles.smoke} viewBox="0 0 40 34" aria-hidden focusable="false">
    <path d="M10 30 C 6 22, 18 20, 14 12 C 12 6, 22 4, 20 0" />
    <path d="M20 30 C 16 22, 28 20, 24 12" />
  </svg>
);

const BuildingRoof = ({ type }: Props) => {
  const kind: RoofKind = type ? ROOF_BY_BUILDING_TYPE[type] : 'tile';

  if (kind === 'hedge') {
    return <div className={styles.hedge} aria-hidden />;
  }

  return (
    <div
      className={classnames(styles.roof, {
        [styles.slate]: kind === 'slate',
        [styles.tile]: kind === 'tile',
        [styles.flat]: kind === 'flat' || kind === 'pool',
        [styles.pool]: kind === 'pool',
      })}
      aria-hidden
    >
      <div className={styles.slope} />
      {kind === 'slate' && (
        <>
          <div className={styles.chimney} />
          <Smoke />
          <div className={styles.oeil} />
        </>
      )}
      {kind === 'tile' && (
        <>
          <Rooster />
          <div className={styles.lucarne}>
            <div className={styles.lucarneRoof} />
            <div className={styles.lucarneWindow} />
          </div>
        </>
      )}
      {kind === 'pool' && (
        <div className={styles.parasol}>
          <div className={styles.canopy} />
          <div className={styles.pole} />
        </div>
      )}
    </div>
  );
};

export default BuildingRoof;
